<template>
	<app-title-bar :icon="['fas', 'fa-info']" subtitle="Stock ID" :title="masterGroup?.name">
		<template #icon>
			<product-category-icon :category="code" size="medium"></product-category-icon>
		</template>

		<app-button to="/product-data/product-categories" class="ml-2" icon="fa-circle-left">
			Back
		</app-button>
	</app-title-bar>

	<!--		<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-5">-->
	<!--			<app-panel v-for="analysisGroup in masterGroup.analysis_groups" class="mt-5" :title="analysisGroup.name">-->
	<!--				<router-link-->
	<!--					class="block text-blue-600 hover:underline"-->
	<!--					v-for="productGroup in analysisGroup.product_groups"-->
	<!--					:key="productGroup.code"-->
	<!--					:to="`/product-data/product-groups/${productGroup.code}`">-->
	<!--					{{ productGroup.code }} {{ productGroup.name }}-->
	<!--				</router-link>-->
	<!--			</app-panel>-->
	<!--		</div>-->

	<div v-if="!loading" class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 mt-5">
		<router-link
			v-for="productGroup in masterGroup?.product_groups"
			:key="productGroup.code"
			class="flex justify-between p-3 border-b border-gray-300 hover:bg-gray-100 cursor-pointer bg-white rounded-md shadow-sm"
			:to="`/product-data/product-groups/${productGroup.code}`">
			<span class="text-gray-600 font-semibold">{{ productGroup.name }}</span>
			<span class="font-semibold text-gray-700">{{ productGroup.code }}</span>
		</router-link>
	</div>

	<!-- Skeleton loader -->
	<div v-else class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 mt-5">
		<div
			v-for="n in 11"
			:key="n"
			class="flex justify-between p-3 py-4 border-b border-gray-300 bg-white rounded-md shadow-sm animate-pulse">
			<span class="h-4 w-72 bg-gray-300 rounded"></span>
			<span class="h-4 w-8 bg-gray-300 rounded"></span>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { onMounted, ref } from 'vue'
	import { useRoute } from 'vue-router'
	import type { MasterGroup } from '@/data/schema/master-group'
	import ProductCategoryIcon from '@/components/partials/icons/ProductCategoryIcon.vue'
	import MasterGroupService from '@/services/master-group'

	const masterGroup = ref<MasterGroup>()

	const loading = ref(true)

	const route = useRoute()
	const code = typeof route.params.code === 'string' ? route.params.code : route.params.code[0]

	const load = async () => {
		loading.value = true
		try {
			const api = new MasterGroupService()
			const response = await api.get(code)
			masterGroup.value = response.data.data
		} catch (error) {
			console.error('Error fetching master group:', error)
		} finally {
			loading.value = false
		}
	}

	onMounted(() => {
		load()
	})
</script>
